import { BASE_CONFIG } from "client/config";
export const CONFIG = {
 ...BASE_CONFIG
};
